import React, { useContext } from "react";
import {
    CarouselContainer,
    BlogTextContainer,
    StyledGatsbyImage,
    StyledBlogPostContainer,
    BolgTextHeader,
} from "./BlogCarousel.styles";
import parse from "html-react-parser";
import { Slideshow } from "../../../global/SlideShow/SlideShow";
import { AnalyticsContext } from "../../../../context";

export const BlogCarousel = (props) => {
    const blogItems = props.posts;
    const { handleTealiumEvent } = useContext(AnalyticsContext);
    const useParentWidth = props.useParentWidth ? props.useParentWidth : false;

    return (
        <CarouselContainer>
            <Slideshow
                useParentWidth={useParentWidth}
            >
                {blogItems && blogItems.map((post) => {
                    return(
                        <StyledBlogPostContainer
                            numberOfItems={blogItems.length}
                            href={`/blog${post.uri}`}
                            onClick={() => handleTealiumEvent({ eventcategory: "featured blog", eventaction: "featured blog click", eventlabel: `featured post - ${post.uri}` })}
                        >
                            <StyledGatsbyImage
                                image={post.featuredImage?.node?.localFile?.childImageSharp?.gatsbyImageData?post.featuredImage?.node?.localFile?.childImageSharp?.gatsbyImageData:null}
                                alt={`${post.title}`}
                            />
                            <BlogTextContainer>
                                <BolgTextHeader>{post.title}</BolgTextHeader>
                                {parse(post.excerpt || "")}
                            </BlogTextContainer>
                        </StyledBlogPostContainer>
                    );
                })}
            </Slideshow>
        </CarouselContainer>
    );
}
